import { render, staticRenderFns } from "./ChecklistSegmentModule.vue?vue&type=template&id=1204beb6&scoped=true"
import script from "./ChecklistSegmentModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistSegmentModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChecklistSegmentModule.vue?vue&type=style&index=0&id=1204beb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204beb6",
  null
  
)

export default component.exports